import React from 'react'
import PropTypes from 'prop-types'
import ReactSwitch from 'react-switch'

const Switch = ({
  id,
  className = '',
  disabled,
  checked,
  ariaLabel = undefined,
  onChange = () => { }
}) => (
  <div data-private>
    <ReactSwitch
      id={id}
      aria-label={ariaLabel}
      className={`react-switch ${className || ''} ${checked ? 'switch-checked' : ''} ${disabled ? 'switch-disabled' : ''}`}
      disabled={disabled}
      checked={checked}
      onChange={onChange}
      width={37}
      height={21}
      handleDiameter={15}
      uncheckedIcon={false}
      checkedIcon={false}
    />
  </div>
)

Switch.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  ariaLabel: PropTypes.string,
  onChange: PropTypes.func
}

export default Switch
